import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import AuthLayout from 'components/Auth/Layout';
import routes from 'routes';

import ResetPasswordForm from './components/ResetPasswordForm';

@inject('authStore', 'userStore', 'routingStore')
@observer
class ForgotPasswordPage extends Component {
  componentDidMount() {
    const {
      authStore: { isAuthenticated },
      routingStore: { replace },
    } = this.props;

    if (isAuthenticated) {
      replace(routes.home);
    }
  }

  render() {
    const {
      authStore: { resetPasswordSubmit },
    } = this.props;
    return (
      <AuthLayout image="/images/backgrounds/reset-password.jpg">
        <ResetPasswordForm onSubmit={resetPasswordSubmit} />
      </AuthLayout>
    );
  }
}

export default ForgotPasswordPage;
